import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import WithdrawSelect from "../withdraw_select/withdrawSelect";
import CoinSearchbox from "../coinsearchbar";
import Select from 'react-select';
import { AXIOS, api_key } from "../../../config";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateCoinList } from "../../../store/coinList";
// import Modal from 'react-modal';

const UpperModal = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [searchResults, setSearchResults] = useState([]);
  const [data, setData] = useState<any>([]);
  let dispatch= useDispatch()

  useEffect(() => {
    (async function () {
      try {
        const response = await AXIOS.post('/getCoinList', {
          api_key: api_key,

        });

        const options = response.data.data.map((coin: any, index: number) => ({
          value: coin.symbol,
          label: coin.name,
          coinId: coin._id,
          imgUrl: coin.image_url.img.data,
          contentType: coin.image_url.img.contentType
        }));
        
        dispatch(updateCoinList(options))
        setSearchResults(options);

        setData(options);
      }
      catch (error: any) {
        toast.error(error.message)
      }
    })();

  }, []);

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  function openModal() {
    setModalOpen(true);
  }

  function closeModal() {
    setModalOpen(false);
  }

  function handleSelectChange(option) {
    setSelectedOption(option);
    closeModal();
  }


  return (
    <>

      {/* <div className="mb-2">
        <span className="text-white">Coin</span>
      </div> */}
      <div>
        <Select
          options={data}
          onMenuOpen={openModal}
          value={selectedOption}
          isSearchable={false}
          placeholder='select coin'
        />

      </div>
      <Modal show={isModalOpen} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select coin to withdraw</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <CoinSearchbox setSelectedOption={setSelectedOption} closeModal={closeModal} searchResults={searchResults} data={data} setSearchResults={setSearchResults} />
        </Modal.Body>
      </Modal>
    </>
  );
};
export default UpperModal;
